export const ACCEPT_INVITATION_COPY = {
  LOADING: 'Loading invitation...',
  ERROR_FALLBACK_TITLE: 'Invitation Not Found',
  ERROR_BODY: 'This invitation may have expired or already been accepted.',
  ERROR_LOAD: 'Failed to load invitation',
  ERROR_ACCEPT: 'Failed to accept invitation',
  ACCEPTED_SNACKBAR: 'Invitation accepted! You are now friends.',
  GO_HOME: 'Go Home',
  TITLE: "You've Been Invited!",
  SUBTITLE_SUFFIX: ' has invited you to join Zporti',
  DESCRIPTION: 'Join to compete with friends in sports prediction challenges!',
  ACCEPT_BUTTON: 'Accept Invitation',
  SIGN_IN_TO_ACCEPT: 'Sign In to Accept',
  CREATE_ACCOUNT: 'Create Account',
  WAVE_EMOJI: '👋',
  GENERIC_INVITER: 'A friend',
} as const;

export const INVITATION_QUERY_KEY_ROOT = ['invitations', 'byToken'] as const;

export const buildInvitationByTokenQueryKey = (token: string | undefined) =>
  [...INVITATION_QUERY_KEY_ROOT, token ?? null] as const;

export const FRIENDS_QUERY_KEY = ['friends'] as const;
export const INVITATIONS_QUERY_KEY = ['invitations'] as const;

/** Slice length for analytics — keeps the raw token out of event payloads. */
export const TOKEN_PREVIEW_LENGTH = 8;
